import { AppShell } from '@mantine/core';
import { useLocation } from 'react-router-dom';

// Auth
import { useAuth } from '../../auth/AuthContext';

// Components
import PostLoginNavbar from './components/PostLoginNavbar/PostLoginNavbar';

// Styles
import styles from './postLoginLayout.module.scss';

const noNavbarPages = [
  /\/candidates\/.+\/jobs\/.+/,
  /console/,
  /cancel-appointment/,
];

const PostLoginLayout = ({ children }) => {
  const { pathname } = useLocation();
  const { user } = useAuth();

  const isNoNavbarRoute = noNavbarPages.some((routeRegex) =>
    routeRegex.test(pathname),
  );
  const hasNavbar = user && !isNoNavbarRoute;

  return (
    <AppShell header={{ height: 50 }}>
      {hasNavbar && (
        <AppShell.Header>
          <PostLoginNavbar />
        </AppShell.Header>
      )}
      <AppShell.Main className={styles.main}>{children}</AppShell.Main>
    </AppShell>
  );
};

export default PostLoginLayout;
